<template>
    <main class="dashboard">
        <div class="headerTop">
            <Header @change-section="($event) => { visibleSection = $event }" :currentSection="visibleSection"
                :chartLoaded="chartLoaded" />
        </div>
        <div class="underHeader">
            <div v-if="has_conciliator" v-show="visibleSection == 'conciliador'" class="conciliador-container">
                <section class="dashboard-section consolidado-valores">
                    <div class="container is-half">
                        <SectionHeader title="Resumen de tu salud financiera"
                            description="Mira en línea tus cuentas por cobrar, por pagar y sus vencimientos en una proyección de caja." />
                        <Consolidation :isVisible="visibleSection == 'conciliador'"
                            @onChartRendered="onChartRendered" />
                    </div>
                </section>
                <DashboardMainTabs class="my-6">
                    <template v-slot:obligations>
                        <Obligations :isVisible="visibleSection == 'conciliador'" />
                    </template>
                    <template v-slot:stament>
                        <BankMovements />
                    </template>
                </DashboardMainTabs>
                <section class="is-hidden-tablet my-4">
                    <div class="notification is-info is-light py-5">
                        <h3 class="is-size-5 mb-2">Importante</h3>
                        <p>
                            Te recomendamos utilizar la versión de escritorio para
                            agregar nuevos documentos.
                        </p>
                    </div>
                </section>
            </div>
            <AccountsPlan v-if="has_classificator" v-show="visibleSection == 'accounts_plan'" />
            <Financiamiento v-if="has_financiamiento" v-show="visibleSection == 'financiamiento'" />
            <DashboardBasic v-show="visibleSection == 'reporte'" :isVisible="visibleSection == 'reporte'"
                :chartLoaded="chartLoaded" />
            <DashboardFileUpload v-if="has_file_upload" v-show="visibleSection == 'fileUpload'" />
            <DashboardClassificator v-if="visibleSection == 'classificator'" />
            <DashboardReports v-if="visibleSection == 'reports'" />
            <div v-show="visibleSection == 'none'">
                <div class="notification is-info is-light py-5">
                    <h3 class="is-size-5 mb-2 has-text-weight-bold">Importante</h3>
                    <p>
                        Tu panel personalizado aún no está activo. Si necesitas orientación
                        para configurarlo o reactivar tu acceso, estamos aquí para ayudarte.
                        <br /><br />
                        ¡Escríbenos a
                        <a href="mailto:contacto@cforemoto.com" target="_blank" class="has-text-weight-bold">
                            contacto@cforemoto.com</a>
                        y descubre cómo aprovechar CFOremoto al máximo!
                    </p>
                </div>
            </div>
            <div v-show="visibleSection == ''" />

        </div>

    </main>
</template>

<script>
import BankMovements from "@/components/bankMovements/BankMovements";
import Consolidation from "@/components/dashboard/consolidation/Consolidation";
import Header from "@/components/dashboard/Header";
import DashboardMainTabs from "@/components/dashboardMainTabs/DashboardMainTabs";
import Obligations from "@/components/obligations/Obligations";
import SectionHeader from "@/components/sectionHeader/SectionHeader";
import AccountsPlan from "@/views/AccountsPlan";
import DashboardBasic from "@/views/DashboardBasic";
import DashboardClassificator from "@/views/DashboardClassificator";
import DashboardFileUpload from "@/views/DashboardFileUpload";
import DashboardReports from "@/views/DashboardReports";
import Financiamiento from "@/views/Financiamiento";
import { mapState } from "vuex";

export default {
    name: "Dashboard",
    components: {
        Consolidation,
        Header,
        Obligations,
        DashboardMainTabs,
        BankMovements,
        SectionHeader,
        DashboardBasic,
        DashboardFileUpload,
        DashboardClassificator,
        AccountsPlan,
        Financiamiento,
        DashboardReports
    },
    methods: {
        onChartRendered() {
            this.chartLoaded = true;
        },
        setVisibleSectionFromUser(user) {
            this.visibleSection = 'none';
            if (user) {
                if ((!user.has_conciliator && user.has_embedded_report) || !user.has_embedded_report) {
                    this.chartLoaded = true;
                }
                //order is important
                if (user.has_financiamiento) {
                    this.has_financiamiento = true;
                    // this.visibleSection = 'financiamiento';
                }
                if (user.has_file_upload) {
                    this.has_file_upload = true;
                    // this.visibleSection = 'fileUpload';
                }
                if (user.has_embedded_report) {
                    this.has_embedded_report = true;
                    // this.visibleSection = 'reporte';
                }
                if (user.has_classificator) { //TODO should the classificator be the first option vs the report?
                    this.has_classificator = true;
                    // this.visibleSection = 'classificator';
                }

                if (user.has_financial_report) { //TODO should the classificator be the first option vs the report?
                    this.has_financial_report = true;
                    // this.visibleSection = 'classificator';
                }

                if (user.has_conciliator) {
                    this.has_conciliator = true;
                    // this.visibleSection = 'conciliador';
                }
                const orderFirstDashboardToSee = [this.has_conciliator, this.has_classificator, this.has_file_upload, this.has_embedded_report, this.has_financiamiento]
                const orderedVisibleSection = ['conciliador', 'classificator', 'fileUpload', 'reporte', 'financiamiento']
                const posOrdered = orderFirstDashboardToSee.findIndex(item => item)
                if (posOrdered < 0) {
                    this.visibleSection = 'none'
                    return
                }
                this.visibleSection = orderedVisibleSection[posOrdered]
            }
        },
    },
    watch: {
        user(newValue) {
            if (newValue.user_info_loaded) {
                this.setVisibleSectionFromUser(newValue);
            }
        }
    },
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    data() {
        return {
            visibleSection: '',
            has_conciliator: false,
            has_embedded_report: false,
            has_financiamiento: false,
            has_file_upload: false,
            has_classificator: false,
            has_financial_report: false,
            chartLoaded: false,
        };
    },
};

</script>
<style scoped>
.headerTop {
    position: sticky;
    top: 0;
    /* left: 0; */
    width: 100%;
    background-color: white;
    z-index: 10;
    padding-bottom: 10px;
}

.underHeader {
    /* margin-top: 120px; */
    position: relative;
}
</style>